export default {
  fields: {
    demo: {
      label: 'Utwórz demo',
    },
    ai: {
      label: 'Zoptymalizowane przez AI',
    },
    restaurant_type: {
      label: 'Wybierz typ restauracji',
      types: {
        Pizza: 'Pizza 🍕',
        PizzaDelivery: 'Pizza z dostawą 🍕🚗',
        PizzaNeapolitan: 'Pizza neapolitańska 🍕',
        Italian: 'Włoska 🇮🇹',
        Burger: 'Burger 🍔',
        Turkish: 'Turecka 🇹🇷',
        Mexican: 'Meksykańska 🌮',
        Sushi: 'Sushi 🍱',
        Japanese: 'Japońska 🇯🇵',
        Vietnamese: 'Wietnamska 🇻🇳',
        Thai: 'Tajska 🇹🇭',
        Asian: 'Azjatycka 🍜',
        Indian: 'Indyjska 🥘',
        Bowls: 'Bowle 🥣',
        Vegan: 'Wegańska 🥑',
        Greek: 'Grecka 🏛️',
        Cafe: 'Café ☕️',
        Brunch: 'Brunch 🍵',
        Oriental: 'Orientalna / bliskowschodnia 🧆',
        Spanish: 'Hiszpańska / tapas 🇪🇸',
        Persian: 'Perska 🫖',
      },
    },
    plugins: {
      reservations: 'Rezerwacje',
      reservations_plan_hint:
        'Rezerwacje wymagają planu Partner. Zostaniesz poproszony o jego aktywację dla {{name}} podczas tworzenia strony.',
      catering: 'Catering',
      events: 'Wydarzenia',
    },
    quarter: {
      label: 'Dzielnica',
      address_placeholder: 'Wpisz adres',
      quarter_placeholder: 'Wpisz dzielnicę',
    },
    delivery_areas: {
      label: 'Jakie obszary miasta obsługujesz?',
      city_placeholder: 'Wpisz miasto',
      district_placeholder: 'Dzielnica 1, Dzielnica 2, Dzielnica 3',
    },
    best_dishes: {
      label: 'Jakie są Twoje 3 najlepsze dania?',
      placeholder: 'Wpisz dania (Burger z kurczakiem, Cheeseburger itp.)',
    },
    dietary_attributes: {
      label: 'Czy masz opcje dla osób, które chcą jeść:',
      placeholder: 'Wybierz atrybuty dietetyczne',
      types: {
        vegetarian: 'Wegetariańskie',
        vegan: 'Wegańskie',
        halal: 'Halal',
        gluten_free: 'Bez glutenu',
        dairy_free: 'Bez laktozy',
        spicy: 'Ostre',
      },
    },
    family_owned: {
      label: 'Rodzinny biznes?',
      yes: 'Tak',
      no: 'Nie',
    },
    business_founding_year: {
      label: 'Kiedy powstała restauracja (rok)?',
    },
    business_owners: {
      label: 'Właściciele firmy',
      placeholder: 'Wpisz właściciela firmy',
    },
    notes: {
      label: 'Dodaj dodatkowe uwagi (opcjonalnie)',
      placeholder: 'Np. restauracja nastawiona na społeczność, inicjatywy, własność pary...',
    },
    about_us: {
      title: 'O nas (podgląd)',
    },
  },
  sections: {
    plugins: 'Wtyczki',
    company_info: 'Generuj informacje o firmie',
  },
  buttons: {
    find_district: 'Znajdź dzielnicę',
    generate: 'Generuj',
    products: 'Produkty',
    add: 'Dodaj',
  },
};
